import * as React from 'react';

import { ViewLarge, ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { UnitFragment } from '__generated__/api/types';

import { UitkHeading } from 'uitk-react-text';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutColumns } from 'uitk-react-layout-columns';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkUnformattedHtml } from 'uitk-react-unformatted-html';

interface PropertyInfoSectionProps {
  propertyInfoSection: UnitFragment.RoomAmenities;
}

export const PropertyInfoSection: React.FunctionComponent<PropertyInfoSectionProps> = ({ propertyInfoSection }) => {
  const { header, bodySubSections } = propertyInfoSection || {};

  if (!(header?.text || bodySubSections?.length)) {
    return null;
  }

  return (
    <>
      <div className="l-b-padding-six xl-b-padding-six">
        <UitkHeading level={3} size={600}>
          {header.text}
        </UitkHeading>
      </div>
      <Viewport>
        <ViewSmall>
          <>
            {bodySubSections.map(bodySection =>
              bodySection.contents.map((content, index) => (
                <RoomAmenityContent key={`dialog-room-amenity-${index}`} roomAmenity={content} />
              ))
            )}
          </>
        </ViewSmall>
        <ViewMedium>
          <UitkLayoutColumns minWidth="half_width" columns={2}>
            {bodySubSections.map(bodySection =>
              bodySection.contents.map((content, index) => (
                <RoomAmenityContent key={`dialog-room-amenity-${index}`} roomAmenity={content} />
              ))
            )}
          </UitkLayoutColumns>
        </ViewMedium>
        <ViewLarge>
          <>
            {bodySubSections.map(bodySection =>
              bodySection.contents.map((content, index) => (
                <RoomAmenityContent key={`dialog-room-amenity-${index}`} roomAmenity={content} />
              ))
            )}
          </>
        </ViewLarge>
      </Viewport>
    </>
  );
};
PropertyInfoSection.displayName = 'PropertyInfoSection';

export const RoomAmenityContent: React.FC<{ roomAmenity: UnitFragment.Contents }> = ({ roomAmenity }) => {
  const { header, items } = roomAmenity;

  if (!header) return null;

  return (
    <UitkSpacing margin={{ inlineend: 'three', blockend: 'three', blockstart: 'three' }} data-stid="room-amenities-content">
      <div>
        <UitkLayoutFlex space="two">
          <UitkLayoutFlexItem>
            {header.icon?.id && (
              <UitkSpacing padding={{ inlineend: 'three' }}>
                <UitkIcon name={header.icon?.id} size={UitkIconSize.MEDIUM} />
              </UitkSpacing>
            )}
          </UitkLayoutFlexItem>
          <UitkHeading level={3} size={500}>
            {header.text}
          </UitkHeading>
        </UitkLayoutFlex>
        <UitkUnformattedHtml theme="secondary">
          {items.map((amenity, index) => (
            <UitkSpacing key={`dialog-room-amenity-item-${index}`} margin={{ blockstart: 'two' }} padding={{ inlinestart: 'twelve' }}>
              <div dangerouslySetInnerHTML={{ __html: amenity.content.text }} />
            </UitkSpacing>
          ))}
        </UitkUnformattedHtml>
      </div>
    </UitkSpacing>
  );
};
